import useGet from "#hooks/useGet.js";
import { WebLayout } from "#layouts";
import { WebRoutePath } from "#routes/routePath.jsx";
import ENDPOINTS from "#services/endPoints.js";
import QUERY_KEYS from "#services/queryKeys.js";
import { useNavigate } from "react-router-dom";

export default function WebDashboard() {
  const navigation = useNavigate();

  const { data: dashboardData, isLoading: isDashboardLoading } = useGet(
    ENDPOINTS.DASHBOARD,
    [QUERY_KEYS.DASHBOARD_QUERY_KEY]
  );
  console.log(dashboardData, "dashboardData");
  const data = dashboardData?.data || {};
  if (isDashboardLoading) {
    return (
      <WebLayout>
        <section className="common-section spacer">
          <div
            className="container d-flex justify-content-center align-items-center"
            style={{ height: "60vh" }}
          >
            <div
              className="spinner-border"
              style={{ color: "#88bd42" }}
              role="status"
            >
              <span className="visually-hidden">Loading...</span>
            </div>
          </div>
        </section>
      </WebLayout>
    );
  }
  return (
    <WebLayout>
      <section className="common-section spacer">
        <div className="container">
          <div className="dashboard-card-wrapper">
            <div className="row row-cols-1 row-cols-sm-2 row-cols-md-3 row-cols-xl-4 g-4">
              <div className="col">
                <div className="dashboard-card-item">
                  <div className="dashboard-card-content">
                    <div className="dashboard-card-icon">
                      <img
                        src="/assets/images/icons/total-users-icon.png"
                        alt="Icon"
                      />
                    </div>
                    <div className="dashboard-card-info">
                      <h2>Growers</h2>
                      <p>{data.totalGrowers ?? 0}</p>
                    </div>
                  </div>
                  <div className="dashboard-card-stats">
                    {/* <span className="dash-stats-icon">
                      <img
                        src="/assets/images/icons/grow-arrow-icon.svg"
                        alt="Progress Down"
                      />
                    </span>
                    <p>
                      <span className="">8.5%</span>Up from yesterday
                    </p> */}
                    <span className="dash-stats-icon">
                      <img
                        src={`/assets/images/icons/${
                          data.growerProgress >= 0
                            ? "grow-arrow-icon.svg"
                            : "grow-arrow-icon.svg"
                        }`}
                        alt="Progress"
                      />
                    </span>
                    <p>
                      <span
                        className={
                          data.growerProgress >= 0
                            ? "text-success"
                            : "text-danger"
                        }
                      >
                        {data.growerProgress ?? 0}%
                      </span>{" "}
                      {data.growerProgress >= 0 ? "Up" : "Down"} from yesterday
                    </p>
                  </div>
                </div>
              </div>
              {/* <div className="col">
                <div className="dashboard-card-item">
                  <div className="dashboard-card-content">
                    <div className="dashboard-card-icon">
                      <img
                        src="/assets/images/icons/total-task-icon.png"
                        alt="Icon"
                      />
                    </div>
                    <div className="dashboard-card-info">
                      <h2>Total Crops</h2>
                      <p>40</p>
                    </div>
                  </div>
                  <div className="dashboard-card-stats">
                    <span className="dash-stats-icon">
                      <img
                        src="/assets/images/icons/grow-arrow-icon.svg"
                        alt="Progress Up"
                      />
                    </span>
                    <p>
                      <span className>0%</span>Up From Yesterday
                    </p>
                  </div>
                </div>
              </div> */}
              <div className="col">
                <div className="dashboard-card-item">
                  <div className="dashboard-card-content">
                    <div className="dashboard-card-icon">
                      <img
                        src="/assets/images/icons/dash-cube-icon.png"
                        alt="Icon"
                      />
                    </div>
                    <div className="dashboard-card-info">
                      <h2>Total Scouting</h2>
                      <p> {data.totalScouting ?? 0}</p>
                    </div>
                  </div>
                  <div className="dashboard-card-stats">
                    <span className="dash-stats-icon">
                      <img
                        src={`/assets/images/icons/${
                          data.scoutingProgress >= 0
                            ? "grow-arrow-icon.svg"
                            : "grow-arrow-icon.svg"
                        }`}
                        alt="Progress Up"
                      />
                    </span>
                    <p>
                      <span
                        className={
                          data?.scoutingProgress >= 0
                            ? "text-success"
                            : "text-danger"
                        }
                      >
                        {data.scoutingProgress ?? 0}%
                      </span>{" "}
                      {data.scoutingProgress >= 0 ? "Up" : "Down"} from
                      yesterday
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="row g-4">
            <div className="col-lg-12">
              <div className="dashboard_new_wrapper">
                <div className="dashboard_blk_header d-flex justify-content-between align-items-center gap-3 mb-3">
                  <h2 className="fs-4 fw-medium mb-0">Recent Growers</h2>
                  <span
                    className="view-all-btn"
                    onClick={() =>
                      navigation(WebRoutePath.GROWER_MANAGEMENT.path)
                    }
                  >
                    View All
                  </span>
                </div>
                <div className="dash_content_wrapper">
                  <div className="table-blk table-responsive">
                    <table>
                      <thead>
                        <tr>
                          <th>Grower Name</th>
                          <th>Location</th>
                        </tr>
                      </thead>
                      <tbody>
                        {data.growers?.map((grower) => (
                          <tr key={grower._id}>
                            <td>{`${grower.firstName} ${grower.lastName}`}</td>
                            <td>{grower.location}</td>
                          </tr>
                        )) || (
                          <tr>
                            <td colSpan="2">No recent growers</td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </WebLayout>
  );
}
